// Port of pension_report/config.py — do not edit rates here without also updating the Python source.
export const CFG = Object.freeze({
  // True: 고객이 세후 금액을 희망한다는 의미 → 인출 시 세전으로 gross-up
  TARGET_IS_AFTER_TAX: true,

  // 이자/배당 원천징수세율 (지방소득세 포함, 15.4%)
  TAX_INTEREST_DIVIDEND: 0.154,

  // 연금소득세 (나이 구간별, 지방소득세 포함)
  PENSION_TAX_55_69: 0.055,
  PENSION_TAX_70_79: 0.044,
  PENSION_TAX_80_PLUS: 0.033,

  // 연간 연금 1,500만원 초과 시 기타소득세 (미사용 — 향후 확장용)
  HIGH_PENSION_TAX: 0.165,
  HIGH_PENSION_ANNUAL_THRESHOLD: 15_000_000,

  // 연간 펀드/ETF 운용보수 (TER 근사치, 0.30%)
  ANNUAL_MANAGEMENT_FEE: 0.003,

  // 매수 거래 수수료 (0.015%, KRX 기준)
  TRADE_FEE_RATE: 0.00015,

  // 월 납입금에 거래 수수료 적용 여부
  APPLY_TRADE_FEE_TO_MONTHLY: true,
});
